import React from 'react';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import ReactTable from "react-table";
import "react-table/react-table.css";
import Paper from '@material-ui/core/Paper';
import _ from "lodash";
import SaveIcon from '@material-ui/icons/Save';
import Back from '@material-ui/icons/ArrowBack';
import withFixedColumns from "react-table-hoc-fixed-columns";

import api from '../api/api';

const ReactTableFixedColumns = withFixedColumns(ReactTable);

const requestData = (pageSize, page, sorted, filtered, rawData) => {
  return new Promise((resolve, reject) => {
    // You can retrieve your data however you want, in this case, we will just use some local data.
    let filteredData = rawData;
    // You can use the filters in your request, but you are responsible for applying them.
    if (filtered.length) {
      filteredData = filtered.reduce((filteredSoFar, nextFilter) => {
        return filteredSoFar.filter(row => {
          var reg = new RegExp(nextFilter.value,"i");;
          return !!((row[nextFilter.id] + "").match(reg));
        });
      }, filteredData);
    }
    // You can also use the sorting in your request, but again, you are responsible for applying it.
    const sortedData = _.orderBy(
      filteredData,
      sorted.map(sort => {
        return row => {
          if (row[sort.id] === null || row[sort.id] === undefined) {
            return -Infinity;
          }
          return typeof row[sort.id] === "string"
            ? row[sort.id].toLowerCase()
            : row[sort.id];
        };
      }),
      sorted.map(d => (d.desc ? "desc" : "asc"))
    );

    // You must return an object containing the rows of the current page, and optionally the total pages number.
    const res = {
      rows: sortedData.slice(pageSize * page, pageSize * page + pageSize),
      pages: Math.ceil(filteredData.length / pageSize)
    };
    // Here we'll simulate a server response with 500ms of delay.
    setTimeout(() => resolve(res), 1);
  });
};

export default class DocumentBulkUpdate extends React.Component {

  constructor() { 
    super();
    this.state = {
      obj :''  ,
      rawData:null,
      data: [],
      pages: null,
      loading: true,
      selected: [],
      selectAll: 1,
      rowsPerPage: 5,
      page: 0,
      order: 'asc',
      orderBy: 'calories',
      bulkData: [],
      checkedBulkData: [],
      userDeptList:[],
      currentStatusList: [],
      newUserDeptValues: [],
      newUserNameValues: [],
      newCurrentStatusValues: [],
      newStatusDateValues: [],
      userDepartment: '',
      userName: '',
      currentStatus: '',
      statusDate: ''
    }
    this.fetchData = this.fetchData.bind(this);
  }

  fetchData(state, instance) {
    this.setState({ loading: true, fetchDataState: state });
    if(!!this.state.rawData) {
      requestData(
        state.pageSize,
        state.page,
        state.sorted,
        state.filtered,
        this.state.rawData
      ).then(res => {
        // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
        this.setState({
          data: res.rows,
          pages: res.pages,
          loading: false
        });
      });
    }
  }

	checkBoxUserDeptRow = (document_control_no, index, value) => {
    var docAvailable = 0;
    for(var i = 0; i < this.state.checkedBulkData.length; i++) {
      if(this.state.checkedBulkData[i].document_control_no === document_control_no) {
        docAvailable = 1;
        break;
      }
    }
    if(docAvailable) {
      var checkedBulkValues = this.state.checkedBulkData;
      checkedBulkValues[i].user_dept=value;
      this.setState({
        checkedBulkData: checkedBulkValues
      });
    }
    var bulkData= this.state.bulkData;
    bulkData[index].user_dept=value;
    var updatedValues=bulkData;
    var newSelectedValues1 =this.state.newUserDeptValues;
    newSelectedValues1[index]=value;
    var newSelectedValues= newSelectedValues1;
    this.setState({
      bulkData: updatedValues,
      newUserDeptValues: newSelectedValues
    });
  }

	checkBoxUserNameRow = (document_control_no, index, value) => {
    var docAvailable = 0;
    for(var i = 0; i < this.state.checkedBulkData.length; i++) {
      if(this.state.checkedBulkData[i].document_control_no === document_control_no) {
        docAvailable = 1;
        break;
      }
    }
    if(docAvailable) {
      var checkedBulkValues = this.state.checkedBulkData;
      checkedBulkValues[i].user_name=value;
      this.setState({
        checkedBulkData: checkedBulkValues
      });
    }
    var bulkData= this.state.bulkData;
    bulkData[index].user_name=value;
    var updatedValues=bulkData;
    var newSelectedValues1 =this.state.newUserNameValues;
    newSelectedValues1[index]=value;
    var newSelectedValues= newSelectedValues1;
    this.setState({
      bulkData: updatedValues,
      newUserNameValues: newSelectedValues
    });
  }

	checkBoxCurrentStatusRow = (document_control_no, index, value) => {
    var docAvailable = 0;
    for(var i = 0; i < this.state.checkedBulkData.length; i++) {
      if(this.state.checkedBulkData[i].document_control_no === document_control_no) {
        docAvailable = 1;
        break;
      }
    }
    if(docAvailable) {
      var checkedBulkValues = this.state.checkedBulkData;
      checkedBulkValues[i].current_status=value;
      this.setState({
        checkedBulkData: checkedBulkValues
      });
    }
    var bulkData= this.state.bulkData;
    bulkData[index].current_status=value;
    var updatedValues=bulkData;
    var newSelectedValues1 =this.state.newCurrentStatusValues;
    newSelectedValues1[index]=value;
    var newSelectedValues= newSelectedValues1;
    this.setState({
      bulkData: updatedValues,
      newCurrentStatusValues: newSelectedValues
    });
  }

	checkBoxStatusDateRow = (document_control_no, index, value) => {
    var docAvailable = 0;
    for(var i = 0; i < this.state.checkedBulkData.length; i++) {
      if(this.state.checkedBulkData[i].document_control_no === document_control_no) {
        docAvailable = 1;
        break;
      }
    }
    if(docAvailable) {
      var checkedBulkValues = this.state.checkedBulkData;
      checkedBulkValues[i].status_date=value;
      this.setState({
        checkedBulkData: checkedBulkValues
      });
    }
    var bulkData= this.state.bulkData;
    bulkData[index].status_date=value;
    var updatedValues=bulkData;
    var newSelectedValues1 =this.state.newStatusDateValues;
    newSelectedValues1[index]=value;
    var newSelectedValues= newSelectedValues1;
    this.setState({
      bulkData: updatedValues,
      newStatusDateValues: newSelectedValues
    });
  }
  
  toggleRow(document_control_no) {
    let docAvailable = 0;
    for(var i = 0; i < this.state.checkedBulkData.length; i++) {
      if(this.state.checkedBulkData[i].document_control_no === document_control_no) {
        docAvailable = 1;
        break;
      }
    }
    if(docAvailable) {
      var checkedBulkValues = this.state.checkedBulkData;
      var filtered1 = checkedBulkValues.filter(function(value, index, arr){
        return index !== i;
      });
      this.setState({
        checkedBulkData: filtered1
      });
    }
    else {
      for(var j = 0; j < this.state.bulkData.length; j++) {
        if(this.state.bulkData[j].document_control_no === document_control_no) {
          break;
        }
      }
      this.setState({
        checkedBulkData: [...this.state.checkedBulkData, {document_control_no: this.state.bulkData[j].document_control_no, user_dept: this.state.bulkData[j].user_dept, user_name:this.state.bulkData[j].user_name, current_status: this.state.bulkData[j].current_status, status_date:this.state.bulkData[j].status_date }]
      });
    }
    const newSelected = Object.assign({}, this.state.selected);
    newSelected[document_control_no] = !this.state.selected[document_control_no];
    this.setState({
      selected: newSelected,
      selectAll: 2
    });
	}

  toggleSelectAll = () => {
    let newSelected = [];
		if (this.state.selectAll === 0) {
			this.state.data.forEach(x => {
        newSelected[x.document_control_no] = true;
			});
    }
		this.setState({
      selected: newSelected,
      checkedBulkData:this.state.selectAll === 0 ? this.state.bulkData : [],
			selectAll: this.state.selectAll === 0 ? 1 : 0
		});
  };

  userDepartmentChange = (e, index, value) => {
    let newSelectedValues = [];
    var bulkData= this.state.bulkData;
    var checkedBulkData= this.state.checkedBulkData;
    this.state.data.forEach(x => {
      newSelectedValues.push(e.target.value);
    });
    for (var i = 0; i < this.state.bulkData.length; i++) {
      bulkData[i].user_dept = e.target.value;
    }
    for (var j = 0; j < this.state.checkedBulkData.length; j++) {
      checkedBulkData[j].user_dept = e.target.value;
    }
    var updatedValues=bulkData;
    var checkedUpdatedvalues = checkedBulkData;
    this.setState({
      newUserDeptValues: newSelectedValues,
      bulkData: updatedValues,
      checkedBulkData: checkedUpdatedvalues,
      userDepartment: e.target.value
		});
  };

  userNameChange = (e, index, value) => {
    let newSelectedValues = [];
    var bulkData= this.state.bulkData;
    var checkedBulkData= this.state.checkedBulkData;
    this.state.data.forEach(x => {
      newSelectedValues.push(e.target.value);
    });
    for (var i = 0; i < this.state.bulkData.length; i++) {
      bulkData[i].user_name = e.target.value;
    }
    for (var j = 0; j < this.state.checkedBulkData.length; j++) {
      checkedBulkData[j].user_name = e.target.value;
    }
    var updatedValues=bulkData;
    var checkedUpdatedvalues = checkedBulkData;
    this.setState({
      newUserNameValues: newSelectedValues,
      bulkData: updatedValues,
      checkedBulkData: checkedUpdatedvalues,
      userName: e.target.value
		});
  };

  currentStatusChange = (e, index, value) => {
    let newSelectedValues = [];
    var bulkData= this.state.bulkData;
    var checkedBulkData= this.state.checkedBulkData;
    this.state.data.forEach(x => {
      newSelectedValues.push(e.target.value);
    });
    for (var i = 0; i < this.state.bulkData.length; i++) {
      bulkData[i].current_status = e.target.value;
    }
    for (var j = 0; j < this.state.checkedBulkData.length; j++) {
      checkedBulkData[j].current_status = e.target.value;
    }
    var updatedValues=bulkData;
    var checkedUpdatedvalues = checkedBulkData;
    this.setState({
      newCurrentStatusValues: newSelectedValues,
      bulkData: updatedValues,
      checkedBulkData: checkedUpdatedvalues,
      currentStatus: e.target.value
		});
  };

  statusDateChange = (e, index, value) => {
    let newSelectedValues = [];
    var bulkData= this.state.bulkData;
    var checkedBulkData= this.state.checkedBulkData;
    this.state.data.forEach(x => {
      newSelectedValues.push(e.target.value);
    });
    for (var i = 0; i < this.state.bulkData.length; i++) {
      bulkData[i].status_date = e.target.value;
    }
    for (var j = 0; j < this.state.checkedBulkData.length; j++) {
      checkedBulkData[j].status_date = e.target.value;
    }
    var updatedValues=bulkData;
    var checkedUpdatedvalues = checkedBulkData;
    this.setState({
      newStatusDateValues: newSelectedValues,
      bulkData: updatedValues,
      checkedBulkData: checkedUpdatedvalues,
      statusDate: e.target.value
		});
  };

  handleReload() {
    window.location.reload();
  }

  handleSubmit = (e) => {
    var companyCode = '001';
    var bulkDocumentList = this.state.checkedBulkData;
    // Invoke Get User Department list API
    api.putBulkDocumentsUpdate(companyCode, bulkDocumentList).then((response) => {
      if(response.status >= 200 && response.status < 300) {
        response.json().then((res) => {
          if(res.status=== "Success") {
            alert('Updated Successfully!!');
            window.location.reload();
          }
          else {
            alert('TODO:: Error Handling in Document Types..');
          }
        });
      }
      else {
        alert('Error Handling in header1.');
      }
    });
  }

  componentWillMount() {
    var companyCode = '001';
    var documentList = this.props.checked;
    // Invoke get user details API
    api.getBulkDocuments(companyCode, documentList).then((response) => {
      if(response.status >= 200 && response.status < 300) {
        response.json().then((res) => {
          if (res) {
            let newSelected = [];
            let newSelectedValues= [];
            let newUserValues= [];
            let newCurrentStatusValues= [];
            let newStatusDateValues= [];
            let allCheckedList = [];
            res.documents.forEach(x => {
              newSelected[x.document_control_no] = true;
              newSelectedValues.push("");
              newUserValues.push("");
              newCurrentStatusValues.push("");
              newStatusDateValues.push("");
              allCheckedList.push({document_control_no: x.document_control_no, user_dept: "", user_name:"", current_status: "", status_date: ""});
            });
            this.setState({
              rawData: res.documents,
              loading: false,
              bulkData: allCheckedList,
              checkedBulkData: allCheckedList,
              newUserDeptValues:newSelectedValues,
              selected: newSelected,
              newUserNameValues: newUserValues,
              newCurrentStatusValues: newCurrentStatusValues,
              newStatusDateValues: newStatusDateValues
            });
            this.fetchData(this.state.fetchDataState);
          }
          else {
            this.setState({
              error: "Something went wrong. Please contact site administrator"
            });
          }
       });
      }
    });
    // Invoke Get User Department list API
    api.getUserDepts().then((response) => {
      if(response.status >= 200 && response.status < 300) {
        response.json().then((res) => {
          if(res.user_departments) {
            let userDeptList = [];
            let keys = [];
            for (var key in res.user_departments) {
              userDeptList.push({label: res.user_departments[key].department_name, value: res.user_departments[key].id});
              keys.push({key});
            }
            this.setState({
              userDeptList : userDeptList
            });
          }
          else {
            alert('TODO:: Error Handling in Document Types..');
          }
        });
      }
      else {
        alert('Error Handling in header1.');
      }
    });
    // Invoke Get Documents Current Status list API
    api.getCurrentStatus().then((response) => {
      if(response.status >= 200 && response.status < 300) {
        response.json().then((res) => {
          if(res.document_status) {
            let currentStatusList = [];
            let keys = [];
            for (var key in res.document_status) {
              currentStatusList.push({label: res.document_status[key].status_value, value: res.document_status[key].id});
              keys.push({key});
            }
            this.setState({
              currentStatusList : currentStatusList
            });
          }
          else {
            alert('TODO:: Error Handling in Document Types..');
          }
        });
      }
      else {
        alert('Error Handling in header1.');
      }
    });
  }

  render() {
    const { data, loading } = this.state;
    const style = {
      padding: "20px",
    };
    var height= {height: ""};
    if (this.state.data.length >= 6) {
      height = {height: "450px"}
    }
    return (
      <div>
        <Paper style={style}>
          <div style={{float:"right", width: "70%", display:"flex"}}>
            <TextField
              value={this.state.userDepartment}
              id="userDepartment"
              name="userDepartment"
              label="User Dept"
              select={true}
              fullWidth
              onChange={this.userDepartmentChange}
            >
              {this.state.userDeptList.map((option,id) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>&nbsp;&nbsp;&nbsp;&nbsp;
            <TextField
              value={this.state.userName}
              id="userName"
              name="userName"
              label="User Name"
              select={true}
              fullWidth
              onChange={this.userNameChange}
            >
              <MenuItem key="1" value="Hemanth">Hemanth</MenuItem>
              <MenuItem key="2" value="Suresh">Suresh</MenuItem>
              <MenuItem key="3" value="Rajesh">Rajesh</MenuItem>
              <MenuItem key="4" value="Mahesh">Mahesh</MenuItem>
            </TextField>&nbsp;&nbsp;&nbsp;&nbsp;
            <TextField
              value={this.state.currentStatus}
              id="currentStatus"
              name="currentStatus"
              label="Current Status"
              select={true}
              fullWidth
              onChange={this.currentStatusChange}
            >
              {this.state.currentStatusList.map((option,id) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>&nbsp;&nbsp;&nbsp;&nbsp;
            <TextField
              value={this.state.statusDate}
              id="statusDate"
              name="statusDate"
              label="Status Date"
              type="date"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              onChange={this.statusDateChange}
            />
          </div>
          <h2 style= {{color:"#4e5b70"}}><legend>Change Assignment</legend></h2>
          <ReactTableFixedColumns
            columns={[
              {
                id: "checkbox",
                accessor: "",
                Cell: ({ original }) => {
                  return (
                    <input
                      type="checkbox"
                      className="checkbox"
                      checked={this.state.selected[original.document_control_no] === true}
                      onChange={() => this.toggleRow(original.document_control_no)}
                    />
                  );
                },
                Header: x => {
                  return (
                    <input
                      type="checkbox"
                      className="checkbox"
                      checked={this.state.selectAll === 1}
                      ref={input => {
                        if (input) {
                          input.indeterminate = this.state.selectAll === 2;
                        }
                      }}
                      onChange={() => this.toggleSelectAll()}
                    />
                  );
                },
                fixed: "left",
                sortable: false,
                width: 45,
                style: { textAlign: 'center', paddingTop: '22px' }
              },
              {
                Header: "Document Control No",
                accessor: "document_control_no",
                width: 170,
                style: { textAlign: 'center', paddingTop: '22px' }
              },
              {
                Header: "Invoice No",
                accessor:"invoice_no",
                style: { textAlign: 'center', paddingTop: '22px' }
              },
              {
                Header: "Invoice Date",
                accessor:"invoice_date",
                style: { textAlign: 'center', paddingTop: '22px' }
              },
              {
                Header: "Vendor",
                id: "vendor",
                accessor: row => (
                  <div>
                    {row.vendor_name !== '' ? 
                                                row.vendor_name +'('+row.vendor_code+')'
                                              : "" }
                  
                  </div>
                ),
                width: 200,
                style: { textAlign: 'center', paddingTop: '22px' }
              },
              {
                Header: "Current User Dept",
                accessor:"department_name",
                width: 150,
                style: { textAlign: 'center', paddingTop: '22px' }
              },
              {
                Header: "Current User Name",
                accessor:"user_name",
                width: 150,
                style: { textAlign: 'center', paddingTop: '22px' }
              },
              {
                Header: "Current Status",
                accessor:"current_status_value",
                width: 150,
                style: { textAlign: 'center', paddingTop: '22px' }
              },
              {
                Header: "Current Status Date",
                accessor:"status_date",
                width: 150,
                style: { textAlign: 'center', paddingTop: '22px' }
              },
              {
                id: "userDepartment",
                accessor: "document_control_no",
                Cell: ({ index, value }) => {
                  return (
                    <TextField
                      value={this.state.newUserDeptValues[index]}
                      id={value}
                      name={value}
                      label="User Dept"
                      select={true}
                      fullWidth
                      onChange={(e) => this.checkBoxUserDeptRow(e.target.name, index, e.target.value, e)}
                    >
                      {this.state.userDeptList.map((option,id) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  );
                },
                Header: "New User Dept",
                sortable: false,
                width: 150
              },
              {
                id: "userName",
                accessor: "document_control_no",
                Cell: ({ index, value }) => {
                  return (
                    <TextField
                      value={this.state.newUserNameValues[index]}
                      id={value}
                      name={value}
                      label="User Name"
                      select={true}
                      fullWidth
                      onChange={(e) => this.checkBoxUserNameRow(e.target.name, index, e.target.value, e)}
                    >
                      <MenuItem key="1" value="Hemanth">Hemanth</MenuItem>
                      <MenuItem key="2" value="Suresh">Suresh</MenuItem>
                      <MenuItem key="3" value="Rajesh">Rajesh</MenuItem>
                      <MenuItem key="4" value="Mahesh">Mahesh</MenuItem>
                    </TextField>
                  );
                },
                Header: "New User Name",
                sortable: false,
                width: 150
              },
              {
                id: "currentStatus",
                accessor: "document_control_no",
                Cell: ({ index, value }) => {
                  return (
                    <TextField
                      value={this.state.newCurrentStatusValues[index]}
                      id={value}
                      name={value}
                      label="Current Status"
                      select={true}
                      fullWidth
                      onChange={(e) => this.checkBoxCurrentStatusRow(e.target.name, index, e.target.value, e)}
                    >
                      {this.state.currentStatusList.map((option,id) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  );
                },
                Header: "New Current Status",
                sortable: false,
                width: 150
              },
              {
                id: "statusDate",
                accessor: "document_control_no",
                Cell: ({ index, value }) => {
                  return (
                    <TextField
                      value={this.state.newStatusDateValues[index]}
                      id={value}
                      name={value}
                      label="Status Date"
                      type="date"
                      fullWidth
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) => this.checkBoxStatusDateRow(e.target.name, index, e.target.value, e)}
                    />
                  );
                },
                Header: "New Status Date",
                sortable: false,
                width: 200
              }
            ]}
            manual
            data={data}
            loading={loading} // Display the loading overlay when we need it
            onFetchData={this.fetchData} // Request new data when things change
            minRows={2}
            style={height}
            filterable={false}
            sortable={false}
            showPagination={false}
            className="-striped -highlight"
          /><br />
          <div className="icon-bar">
            <Button variant="contained" color="primary" size="small" style={{textTransform: 'initial', width: '100px'}} onClick={this.handleSubmit} >
              <SaveIcon />&nbsp;&nbsp;Update
            </Button>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Button variant="contained" size="small" style={{textTransform: 'initial', width: '100px'}} onClick={this.handleReload} >
              <Back />&nbsp;&nbsp;Back
            </Button>
          </div>
        </Paper>
      </div>
    );
  }
}
   


// WEBPACK FOOTER //
// ./src/components/DocumentBulkUpdate.js